module.exports = __webpack_public_path__ + "static/media/st.89c63e7b.svg";